// extracted by mini-css-extract-plugin
module.exports = {"HomePage":"homepage_HomePage__3TK-B","Buttons":"homepage_Buttons__17miD","RedBtn":"homepage_RedBtn__3jibL","jumping":"homepage_jumping__1Y83K"};